import { Box, Card, CardContent, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { CATEGORY_IMAGES } from "../assets/images";
import logoBCT from "../assets/images/logoBCT.png";

const getInitials = (name) =>
  name
    .split(" ")
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();

const PlaceCard = ({ item, link, category }) => {
  const hasImage = Boolean(item.image);

  const fallbackImage = CATEGORY_IMAGES[category] || CATEGORY_IMAGES.tourist;

  const imageToShow = item.image || fallbackImage;

  return (
    <Card
      component={Link}
      to={link}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        textDecoration: "none",
        borderRadius: 2,
        overflow: "hidden",
        backgroundColor: "#fff",
        border: "1px solid rgba(13,59,102,0.12)",
        fontFamily: "var(--font-primary)",
        transition: "all 0.35s ease",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 18px 42px rgba(13,59,102,0.22)",
        },
      }}
    >
      {/* IMAGE / PLACEHOLDER */}
      <Box
        sx={{
          height: 160,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: `url(${imageToShow})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(180deg, rgba(13,59,102,0.15), rgba(13,59,102,0.55))",
          }}
        />

        {/* Watermark Logo */}
        <Box
          component="img"
          src={logoBCT}
          alt="NearbyGuide"
          sx={{
            position: "absolute",
            bottom: 8,
            right: 10,
            width: 75,
            opacity: 0.9,
          }}
        />

        {/* Initials */}
        {!hasImage && (
          <Typography
            sx={{
              position: "relative",
              fontSize: 42,
              fontWeight: 800,
              letterSpacing: 3,
              color: "var(--color-sunshine)",
            }}
          >
            {getInitials(item.name)}
          </Typography>
        )}
      </Box>

      {/* CONTENT */}
      <CardContent
        sx={{
          p: 2.5,
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: 17,
            fontWeight: 700,
            color: "var(--text-heading)",
            mb: 0.5,
            lineHeight: 1.3,
          }}
        >
          {item.name}
        </Typography>

        <Typography
          sx={{
            fontSize: 14,
            color: "var(--text-secondary)",
            mb: 1.2,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {item.area} • {item.details}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        {item.timing && (
          <Typography
            sx={{
              fontSize: 13,
              color: "var(--text-muted)",
            }}
          >
            ⏰ {item.timing}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default PlaceCard;
